module.exports = __webpack_public_path__ + "static/loading-indicator-2f27f0451cef49811159185acae00b47.gif";